import { Fragment } from "react";
import { Link } from "react-router";

export type Crumb = { label: string; to?: string };

/** Home › Contracts › … The last crumb is the current page (plain text).
 *  The official Crumbs part (links and spans in a row, `›` between them), read out as an
 *  ordered list: each crumb is a list item, the separators are hidden from screen readers. */
export function Breadcrumbs({ items }: { items: Crumb[] }) {
  if (items.length === 0) return null;
  return (
    <nav aria-label="Breadcrumb">
      <div role="list" className="crumbs">
        {items.map((c, i) => {
          const last = i === items.length - 1;
          return (
            <Fragment key={`${i}-${c.label}`}>
              {i > 0 ? <span aria-hidden="true">›</span> : null}
              <span role="listitem">
                {last || !c.to ? <span aria-current={last ? "page" : undefined}>{c.label}</span> : <Link to={c.to}>{c.label}</Link>}
              </span>
            </Fragment>
          );
        })}
      </div>
    </nav>
  );
}
